import { createRouter } from '@tanstack/react-router';
import { rootRoute } from './routes/__root';
import { authenticatedRoute } from './routes/_authenticated';
import { apiKeysRoute } from './routes/_authenticated/api-keys';
import { cacheRoute } from './routes/_authenticated/cache';
import { contentRoute } from './routes/_authenticated/content';
import { contentEditRoute } from './routes/_authenticated/content.$type.$id.edit';
import { contentNewRoute } from './routes/_authenticated/content.$type.new';
import { dashboardRoute } from './routes/_authenticated/dashboard';
import { formsRoute } from './routes/_authenticated/forms';
import { formEditRoute } from './routes/_authenticated/forms.$formId.edit';
import { formNewRoute } from './routes/_authenticated/forms.new';
import { submissionDetailRoute } from './routes/_authenticated/forms.submissions.$submissionId';
import { schemasRoute } from './routes/_authenticated/schemas';
import { schemaEditRoute } from './routes/_authenticated/schemas.$type.edit';
import { schemaNewRoute } from './routes/_authenticated/schemas.new';
import { indexRoute } from './routes/index';
import { loginRoute } from './routes/login';

export const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  authenticatedRoute.addChildren([
    dashboardRoute,
    schemasRoute,
    schemaNewRoute,
    schemaEditRoute,
    contentRoute,
    contentNewRoute,
    contentEditRoute,
    formsRoute,
    formNewRoute,
    formEditRoute,
    submissionDetailRoute,
    apiKeysRoute,
    cacheRoute,
  ]),
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
